export const FREE_TRIAL = 'free_trial';
export const INTRO_PRICE = 'intro_price';
export const PROTO_REASON_HAS_FACE_PHOTOS = 'HAS_FACE_PHOTOS_TRUE';

export const DELETE_USER_PHOTO = 'DELETE_USER_PHOTO';
export const DELETE_USER_PHOTO_FAILURE = 'DELETE_USER_PHOTO_FAILURE';
export const DELETE_USER_PHOTO_SUCCESS = 'DELETE_USER_PHOTO_SUCCESS';

export const FETCH_PROFILE = 'FETCH_PROFILE';
export const FETCH_PROFILE_REQUEST = 'FETCH_PROFILE_REQUEST';
export const FETCH_PROFILE_SUCCESS = 'FETCH_PROFILE_SUCCESS';
export const FETCH_PROFILE_ERROR = 'FETCH_PROFILE_ERROR';

export const USER_DATA_SET = 'USER_DATA_SET';
export const USER_DATA_SET_SUCCESS = 'USER_DATA_SET_SUCCESS';
export const USER_DATA_SET_SUCCESS_WITHOUT_REFRESH_RECS =
  'USER_DATA_SET_SUCCESS_WITHOUT_REFRESH_RECS';

export const UPDATE_USER_DATA_LOCALLY = 'UPDATE_USER_DATA_LOCALLY';

export const USER_DATA_SET_FAILURE = 'USER_DATA_SET_FAILURE';
export const UPDATE_USER_JOB = 'UPDATE_USER_JOB';
export const UPDATE_USER_SCHOOL = 'UPDATE_USER_SCHOOL';
export const USER_SET_PHOTOS = 'USER_SET_PHOTOS';
export const GET_FACEBOOK_EMAIL = 'GET_FACEBOOK_EMAIL';
export const GET_FACEBOOK_EMAIL_SUCCESS = 'GET_FACEBOOK_EMAIL_SUCCESS';

export const UPDATE_TINDER_U_STATUS = 'UPDATE_TINDER_U_STATUS';

export const FETCH_READ_RECEIPT_SUBSCRIPTION = 'FETCH_READ_RECEIPT_SUBSCRIPTION';
export const SET_READ_RECEIPT_SUBSCRIPTION = 'SET_READ_RECEIPT_SUBSCRIPTION';
export const FETCH_READ_RECEIPT_SUBSCRIPTION_SUCCESS = 'FETCH_READ_RECEIPT_SUBSCRIPTION_SUCCESS';
export const SET_READ_RECEIPT_SUBSCRIPTION_SUCCESS = 'SET_READ_RECEIPT_SUBSCRIPTION_SUCCESS';
export const CONSUME_READ_RECEIPT = 'CONSUME_READ_RECEIPT';
export const CONSUME_READ_RECEIPT_SUCCESS = 'CONSUME_READ_RECEIPT_SUCCESS';
export const CONSUME_READ_RECEIPT_ERROR = 'CONSUME_READ_RECEIPT_ERROR';
export const CLEAR_READ_RECEIPT_ERROR = 'CLEAR_READ_RECEIPT_ERROR';

export const SET_PHOTO_ORDER = 'SET_PHOTO_ORDER';
export const SET_PHOTO_ORDER_SUCCESS = 'SET_PHOTO_ORDER_SUCCESS';

export const SET_USER_INTERESTS = 'SET_USER_INTERESTS';
export const DELETE_USER_INTERESTS_SUCCESS = 'DELETE_USER_INTERESTS_SUCCESS';

export const UPDATE_CONTACT_CARD = 'UPDATE_CONTACT_CARD';
export const UPDATE_CONTACT_CARD_ERROR = 'UPDATE_CONTACT_CARD_ERROR';
export const UPDATE_CONTACT_CARD_SUCCESS = 'UPDATE_CONTACT_CARD_SUCCESS';

export const REFRESH_PROFILE_NUDGE_RECEIVED = 'REFRESH_PROFILE_NUDGE_RECEIVED';

export const SEND_TUTORIAL_VIEWED_SUCCESS = 'SEND_TUTORIAL_VIEWED_SUCCESS';
export const SEND_GOLD_TUTORIAL_VIEWED = 'SEND_GOLD_TUTORIAL_VIEWED';

export const BOOST_TUTORIAL = 'boost_tutorial';
export const FAST_MATCH_INTRO = 'fast_match_intro';
export const MUTUAL_FRIENDS_TUTORIAL = 'mutuals';

export const UPLOAD_PHOTOS = 'MEDIA/UPLOAD_PHOTOS';
export const UPLOAD_PHOTO_SUCCESS = 'MEDIA/UPLOAD_PHOTO_SUCCESS';
export const UPLOAD_PHOTO_FAILURE = 'MEDIA/UPLOAD_PHOTO_FAILURE';

export const TOGGLE_GLOBAL_MODE = 'TOGGLE_GLOBAL_MODE';
export const UPDATE_GLOBAL_MODE_PREFERENCES = 'UPDATE_GLOBAL_MODE_PREFERENCES';

export const TOGGLE_STICKER_ENABLED = 'TOGGLE_STICKER_ENABLED';
export const SET_ENABLED_STICKER = 'SET_ENABLED_STICKER';
export const SET_HAS_USER_VIEWED_ALL_IN_SCREENS_BEFORE =
  'SET_HAS_USER_VIEWED_ALL_IN_SCREENS_BEFORE';

export const SUPPORTED_TUTORIALS = {
  [BOOST_TUTORIAL]: true,
  [FAST_MATCH_INTRO]: true,
  [MUTUAL_FRIENDS_TUTORIAL]: true,
};

export const SET_SELFIE_VERIFICATION_STATUS = 'SET_SELFIE_VERIFICATION_STATUS';
export const SET_ID_VERIFICATION_STATUS = 'SET_ID_VERIFICATION_STATUS';

export const SET_PROFILE_USER = 'SET_PROFILE_USER';

// selectors
export const SELECTOR_TYPE_CHOICE_SELECTOR = 'choice_selector_v1';
export const SELECTOR_TYPE_MEASUREMENT = 'measurement';
export const SELECTOR_TYPE_MULTI_SELECTION_SET = 'multi_selection_set';
export const SELECTOR_TYPE_SINGLE_SELECTION_SET = 'single_selection_set';

export const SET_HEIGHT_MEASURE_TYPE = 'SET_HEIGHT_MEASURE_TYPE';
